import React, { useContext } from "react";
import "../App.css";
import logo from "../images/logo.png";
import policy from "../images/Brooks_Health_and_Care_Complaints_Policy.pdf";
import footerunderline from "../images/footer_underline.png";
import footerarrow from "../images/footerarrow.png";
import uprightarrow from "../images/uprightarrow.png";
import { Link } from "react-router-dom";
import homesegment8bgIMG from "../images/newhomesegment8bgIMG.jpg";

import { SectionsContext } from "../store/section-context";

function Footer() {
  const { footer } = useContext(SectionsContext);

  const { newsletter, copyright, social, services, commitment } = footer;
  return (
    <div>
      <footer className="pb-3">
        {/* newsletter */}
        <div
          className="homeSegment8 p-md-5"
          style={{
            backgroundImage: `url(${newsletter.uri || homesegment8bgIMG})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "500px",
            width: "100%",
            backgroundColor: "rgb(0 0 0 / 70%)",
            position: "relative",
          }}
        >
          <div className="homeSegment8title ">{newsletter.heading}</div>
          <div className="homeSegment8subtitle py-3">
            {newsletter.description}
          </div>

          <form
            className="emailform pt-4"
            action="https://formspree.io/f/xbjnqrkn"
            method="POST"
            encType="multipart/form-data"
          >
            <div className="email-container">
              <input
                className="emailinput"
                type="email"
                id="email"
                name="email"
                placeholder="Enter Email Address"
              />
              <button className="testimonialbtn footertestimonialbtn">
                <span className="pe-2">{newsletter.cta}</span>{" "}
                <img
                  src={uprightarrow}
                  alt="arrow"
                  className="homeSegment6testimoialarrow footerhomeSegment6testimoialarrow"
                />
              </button>
            </div>
          </form>
        </div>

        <div className="footersection px-5 ">
          <div className="footersection1">
            <a href="/" className="footerlogo">
              <img src={logo} alt="logo" className="footerlogoo" />
            </a>
            <div className="logodesc py-4">{commitment}</div>
            <a
              href={policy}
              target="_blank"
              rel="noopener noreferrer"
              className="complaintpolicylink"
            >
              View Our Complaint Policy
            </a>

            <div className="social-media-icons pt-4">
              {social.platforms.map(({ name, uri }) => (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={uri}
                  className="social-media-icon"
                  key={name}
                >
                  <i
                    className={`fa-brands fa-${name}${
                      name === "facebook" ? "-f" : ""
                    }`}
                  ></i>
                </a>
              ))}
            </div>
            {/* <div className="social-media-icon ">
                <i className="fa-brands fa-linkedin-in "></i>{" "}
              </div> */}

            {/* <div className="social-media-icon">
                <i className="fa-brands fa-twitter"></i>{" "}
              </div> */}
          </div>
          <div className="footersection2">
            <div className="footersection2title">Quick links</div>
            <div className="footerunderline">
              <img src={footerunderline} alt="underline" />
            </div>
            <div className="footersection2links pt-4">
              <div className="pb-md-3 pb-1">
                <a href="/" className="footersection2link">
                  <span className="footerarrow pe-1 ">
                    {" "}
                    <img src={footerarrow} alt="arrow" />{" "}
                  </span>{" "}
                  Home
                </a>
              </div>
              <div className="pb-md-3 pb-1">
                <a href="/about" className="footersection2link">
                  <span className="footerarrow pe-1 ">
                    {" "}
                    <img src={footerarrow} alt="arrow" />{" "}
                  </span>{" "}
                  About us
                </a>
              </div>
              <div className="pb-md-3 pb-1">
                <a href="/services" className="footersection2link">
                  <span className="footerarrow pe-1 ">
                    {" "}
                    <img src={footerarrow} alt="arrow" />{" "}
                  </span>{" "}
                  Services
                </a>
              </div>
              <div className="pb-md-3 pb-1">
                <a href="/job" className="footersection2link">
                  <span className="footerarrow pe-1 ">
                    {" "}
                    <img src={footerarrow} alt="arrow" />{" "}
                  </span>{" "}
                  Careers
                </a>
              </div>
              <div className="pb-3">
                <a href="/contact" className="footersection2link">
                  <span className="footerarrow pe-1 ">
                    {" "}
                    <img src={footerarrow} alt="arrow" />{" "}
                  </span>{" "}
                  Contact
                </a>
              </div>
            </div>
          </div>
          <div className="footersection2">
            <div className="footersection2title">Services</div>
            <div className="footerunderline">
              <img src={footerunderline} alt="underline" />
            </div>

            <div className="footersection2links pt-4">
              {services.map((service, i) => (
                <div key={i} className="footersection2link">
                  <span className="footerarrow pe-1 ">
                    {" "}
                    <img src={footerarrow} alt="arrow" />{" "}
                  </span>{" "}
                  {service}
                </div>
              ))}
            </div>
          </div>
          <div className="footersection2">
            <div className="footersection2title">Contact</div>
            <div className="footerunderline">
              <img src={footerunderline} alt="underline" />
            </div>
            <div className="footersection2links pt-4">
              <div className="footersection2link">
                <span className="footerarrow pe-1 ">
                  <i className="fa-solid fa-location-dot"></i>
                </span>{" "}
                Juniper walk, Kempston, Bedford. MK42 7SX
              </div>
              <Link
                to={`mailto:admin@brookshealthandcare.com?subject=Interested%20In%20Services&body=Hello!%20I'm%20interested%20in...`}
                className="footersection2link"
              >
                <span className="footerarrow pe-1 ">
                  {" "}
                  <i className="fa-solid fa-envelope"></i>
                </span>{" "}
                admin@brookshealthandcare.com
              </Link>
              <div className="footersection2link pt-3">
                <span className="footerarrow pe-1 ">
                  {" "}
                  <i className="fa-solid fa-phone-volume"></i>
                </span>{" "}
                <a className="tellink" href="tel:+441234954004">
                  01234954004
                </a>
              </div>
              <div className="footersection2link pb-3">
                <span className="footerarrow pe-1 ">
                  {" "}
                  <i className="fa-brands contactfooterwhatsapp fa-whatsapp "></i>{" "}
                </span>{" "}
                <a
                  className="tellink"
                  href="https://api.whatsapp.com/send?phone=447449367921"
                >
                  07449367921
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright  text-center ">
          <div>{copyright.text}</div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
